import { Component, Input } from '@angular/core';

@Component({
  selector: 'jbm-inapplicable-value',
  templateUrl: './JBMInapplicableValue.component.html'
})
export class JBMInapplicableValueComponent {
  @Input() value: any;
  @Input() hideValue: boolean=false;

  get hasValue(): boolean {
    return this.value !== null && this.value !== undefined && this.value !== '' && this.value !== 0;
  }
}
